import { EmptyLaunchpad } from "../IDO/styled";

const UpComing = () => {
  return (
    <EmptyLaunchpad>
      <figure>
        <img
          width={314}
          height={282}
          src="/assets/images/common/empty_launchpad.png"
          alt="icon"
        />
      </figure>
      <h2>What's Next?</h2>
      <p>
        Our live launchpad is currently empty, but keep an eye out!
        <br /> Amazing projects will be going live soon.
      </p>
    </EmptyLaunchpad>
  );
};

export default UpComing;
